'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Box = require('./Box');

var _Box2 = _interopRequireDefault(_Box);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var majorScale = _theme2.default.majorScale;
var minorScale = _theme2.default.minorScale;


var IconSize = {
  mini: minorScale(3),
  small: majorScale(2),
  big: majorScale(3)
};

var Icon = function Icon(_ref) {
  var size = _ref.size,
      props = _objectWithoutProperties(_ref, ['size']);

  var realSize = IconSize.hasOwnProperty(size) ? IconSize[size] : size;

  return _react2.default.createElement(_Box2.default, _extends({ is: 'span', width: realSize, height: realSize }, props));
};

Icon.propTypes = {
  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.oneOf(Object.keys(IconSize))]),
  fill: _propTypes2.default.string
};

Icon.defaultProps = {
  size: 'mini',
  fill: 'currentColor',
  display: 'inline-block'
};

exports.default = Icon;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/Icon.js
// module id = 91
// module chunks = 0